module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "box box-primary"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.dados.pesquisa),
      expression: "dados.pesquisa"
    }],
    ref: "filtro_pesquisa",
    staticClass: "form-control",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "placeholder": "Busca: Entre com o NOME ou DOCUMENTO do cliente e pressione enter",
      "name": "filtro_pesquisa",
      "type": "text"
    },
    domProps: {
      "value": (_vm.dados.pesquisa)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.getDataTable($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.dados, "pesquisa", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-md-2"
  }, [_c('button', {
    staticClass: "btn btn-default btn-block",
    on: {
      "click": _vm.getDataTable
    }
  }, [_c('i', {
    staticClass: "fa fa-filter"
  }), _vm._v(" Filtrar")])])]), _vm._v(" "), _c('div', {
    staticClass: "row",
    staticStyle: {
      "margin-top": "15px"
    }
  }, [_c('div', {
    staticClass: "col-sm-12 table-responsive"
  }, [_c('table', {
    staticClass: "table table-bordered table-striped",
    attrs: {
      "aria-describedby": "example1_info",
      "role": "grid",
      "id": "example1"
    }
  }, [_vm._m(1), _vm._v(" "), _c('tbody', _vm._l((_vm.apiData.data), function(item) {
    return _c('tr', {
      key: item.id,
      staticClass: "even",
      attrs: {
        "role": "row"
      }
    }, [_c('td', [_vm._v(_vm._s(item.id))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.nome_razao))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.cpf_cnpj))]), _vm._v(" "), _c('td', [_vm._v("\n                        " + _vm._s(item.telefone1 ? item.telefone1 : '') + " \n                        " + _vm._s(item.telefone2 ? ' | ' + item.telefone2 : '') + "\n                        " + _vm._s(item.tel_ref_comercial ? ' | ' + item.tel_ref_comercial : '') + " \n                        " + _vm._s(item.tel_ref_pessoal ? ' | ' + item.tel_ref_pessoal : '') + " ")]), _vm._v(" "), _c('td', [_c('router-link', {
      staticClass: "btn btn-primary btn-sm",
      attrs: {
        "tag": "button",
        "to": '/cobranca/inadimplentes/detalhe/' + item.id,
        "title": "Detalhes"
      }
    }, [_c('i', {
      staticClass: "fa fa-fw fa-eye"
    })])], 1)])
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-5"
  }, [_vm._v("Mostrando " + _vm._s(this.apiData.from) + " até " + _vm._s(this.apiData.to) + " de " + _vm._s(this.apiData.total) + " registros encontrados.")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-7",
    staticStyle: {
      "text-align": "right"
    }
  }, [_c('laravue-pagination', {
    attrs: {
      "limit": 5,
      "data": _vm.apiData
    },
    on: {
      "pagination-change-page": _vm.getDataTable
    }
  }, [_c('span', {
    attrs: {
      "slot": "prev-nav"
    },
    slot: "prev-nav"
  }, [_vm._v("< Anterior")]), _vm._v(" "), _c('span', {
    attrs: {
      "slot": "next-nav"
    },
    slot: "next-nav"
  }, [_vm._v("Próximo >")])])], 1)])])])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box-header with-border"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_c('b', [_vm._v("Inadimplentes")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', {
    attrs: {
      "role": "row"
    }
  }, [_c('th', {
    staticStyle: {
      "width": "10%"
    }
  }, [_vm._v("Id")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "35%"
    }
  }, [_vm._v("Pessoa")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "20%"
    }
  }, [_vm._v("Cpf/Cnpj")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "20%"
    }
  }, [_vm._v("Telefones")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "15%"
    }
  }, [_vm._v("Ação")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5583ff70"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/cobranca/inadimplentes/inadimplentes.vue
// module id = 397
// module chunks = 1